import { coordinatorFetchers } from "components/coordinator/fetchers";
import { EvtEmployeeCard } from "components/employee/display-card";
import { EvtEmployeeLoaderCard } from "components/employee/loader";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

export const EvtCoordinatorCard = ({ collection, id, role, type = "ID" }) => {
  const fetcher = coordinatorFetchers[type];

  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, "independent-coordinator", id, role],
    queryFn: () => {
      if (!fetcher) throw new Error(`No fetcher defined for ${collection}`);
      return fetcher({ id, role, collection });
    },
  });

  if (isLoading) {
    return <EvtEmployeeLoaderCard />
  }

  if (!data) { return null }

  console.log("role ", role, "data ", data);


  return (
    <div className="flex flex-col gap-2">
      <div className="text-gray-600">{role}</div>
      <EvtEmployeeCard user={data} />
    </div>
  );
};
